import useCssMediaQuery from "./useCssMediaQuery";
import AppHeaderDesktop from "./AppHeaderDesktop";
import AppHeaderMobile from "./AppHeaderMobile";
import WizardStepContent from "./page/wizard/WizardStepContent";
import useWizardFormCtx from "./page/wizard/ctx-provider/useWizardFormCtx";
import useAppCtx from "../app/ctx-provider/useAppCtx";
import { Container } from "@material-ui/core";

const AppHeader = () => {
    const { appCtxBo } = useAppCtx();
    const mainKontaktInvisible = appCtxBo.renderMainKontakt === false;

    const cssMediaQuery = useCssMediaQuery();
    const wizardFormCtx = useWizardFormCtx();
    const actuStep = WizardStepContent.getType(wizardFormCtx.wizardFormBo.activeStep);
    const actuStepAntrag = actuStep === WizardStepContent.P_ANTRAG;
    const isDogorama:boolean = appCtxBo.abTestVersion === 'c';

    return (
        <Container style={{maxWidth: 1164}}>
            {/* KEINE ODER Bedingung, da am Anfang ALLE Werte false sind */}
            {cssMediaQuery.desktopVersion && <AppHeaderDesktop showProduktInfos={actuStepAntrag && mainKontaktInvisible} isDogorama={isDogorama} />}
            {cssMediaQuery.mobileVersion && <AppHeaderMobile showProduktInfos={actuStepAntrag} isDogorama={isDogorama} />}
        </Container>
    );
}

export default AppHeader;